module.exports = __webpack_public_path__ + "assets/img/charim.751449f4.png";